.attachFile {
  --cell-background: #edeef0;

  background: var(--cell-background);
  padding: 8px;
  box-sizing: border-box;
  width: 88px;
  min-height: 88px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;

  & .clear {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 1000;
    color: var(--vkui--color_icon_secondary);
    background: var(--vkui--color_background_content);
    border-radius: 50%;

    &:hover {
      background: var(--vkui--color_background_content);
    }
  }
}

.errorText {
  visibility: visible;
}

.retryButton {
  background: rgb(255 255 255 / 24%);
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.fileOverlay {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 72%);
  color: var(--vkui--color_text_contrast);
  z-index: 999;
  border-radius: 8px;

  &:hover .retryButton {
    visibility: visible;
  }

  &:hover .retryButton + .errorText {
    visibility: hidden;
  }
}

.icon {
  background-color: var(--vkui--color_background_content_alpha);
  border: 1px solid var(--vkui--color_image_border_alpha);
  border-radius: 4px;
  padding: 6px;
  box-sizing: border-box;
  align-self: flex-start;
}

.fileName {
  word-break: break-all;
}
